<form [formGroup]="form" (ngSubmit)="onSave()">

  <div class="formgrid grid">
    <div class="col-12 md:col-6 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Name</h3>
      <input
        id="pkg-name"
        type="text"
        pInputText
        class="inputfield w-full"
        formControlName="name"
        placeholder="e.g. Simple"
      />
      <small *ngIf="form.get('name')?.touched && form.get('name')?.invalid" class="p-error">
        Name is required.
      </small>
    </div>

    <div class="col-12 md:col-6 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">URL slug</h3>
      <input
        id="pkg-slug"
        type="text"
        pInputText
        class="inputfield w-full"
        formControlName="slug"
        placeholder="e.g. simple"
      />
      <small class="block text-500 text-sm mt-1">Lowercase letters, numbers, and hyphens only.</small>
      <small *ngIf="form.get('slug')?.touched && form.get('slug')?.invalid" class="p-error">
        Slug must be lowercase letters, numbers, and hyphens.
      </small>
    </div>

    <div class="col-12 md:col-6 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Region pricing</h3>
      <p-dropdown
        class="w-full"
        inputId="pkg-region"
        formControlName="region"
        [options]="regionOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
      ></p-dropdown>
      <small class="block text-500 text-sm mt-1">"Global" prices it on the mainline picaluna.com; pick a region to price it just for that region.</small>
    </div>

    <div class="col-12 md:col-6 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Tagline</h3>
      <input
        id="pkg-tagline"
        type="text"
        pInputText
        class="inputfield w-full"
        formControlName="tagline"
        placeholder="e.g. Direct cremation, no service"
      />
    </div>

    <div class="col-12 md:col-12 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Description</h3>
      <textarea
        id="pkg-description"
        pInputTextarea
        formControlName="description"
        rows="4"
        class="inputfield w-full"
        placeholder="One paragraph for the brochure-site detail."
      ></textarea>
    </div>

    <div class="col-12 md:col-3 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Service fee (%)</h3>
      <p-inputNumber
        class="w-full"
        inputId="pkg-fee"
        formControlName="serviceFeePercent"
        suffix="%"
        [min]="0"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
      ></p-inputNumber>
      <small class="block text-500 text-sm mt-1">Applied to fee-bearing items. Default 40%.</small>
    </div>

    <div class="col-12 md:col-3 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Price (AUD)</h3>
      <p-inputNumber
        class="w-full"
        inputId="pkg-price"
        formControlName="price"
        mode="currency"
        currency="AUD"
        locale="en-AU"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        placeholder="(POA — quote on enquiry)"
      ></p-inputNumber>
      <small class="block text-500 text-sm mt-1">Leave empty for "Quoted on enquiry".</small>
    </div>

    <div class="col-12 md:col-3 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Active</h3>
      <div class="flex align-items-center gap-2 mt-2">
        <p-inputSwitch formControlName="isActive"></p-inputSwitch>
        <span class="text-700">Shown on picaluna.com</span>
      </div>
      <small class="block text-500 text-sm mt-2">Inactive funeral costs are hidden from the public site.</small>
    </div>

    <div class="col-12 md:col-3 field">
      <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Featured</h3>
      <div class="flex align-items-center gap-2 mt-2">
        <p-inputSwitch formControlName="isFeatured"></p-inputSwitch>
        <span class="text-700">"Most popular"</span>
      </div>
      <small class="block text-500 text-sm mt-2">Featured funeral costs get "Most popular" treatment on the homepage.</small>
    </div>
  </div>

  <hr />

  <h3 class="flex-grow-1 text-500 border-bottom-1 border-200 col-12">Items (inclusions)</h3>
  <p class="block text-500 text-sm mt-1">
    Plain-text inclusion lines for the brochure-site card. Give each a price
    and the breakdown below computes the total. Turn <strong>In fee</strong>
    off for a statutory pass-through (e.g. a government levy) — it's added at
    cost, not marked up, and footnoted with the reason from its Note.
  </p>

  <table class="items-table">
    <thead>
      <tr>
        <th>Label</th>
        <th style="width: 6rem">Qty</th>
        <th style="width: 9rem">Price</th>
        <th style="width: 6rem">In fee</th>
        <th style="width: 3rem"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of items">
      <tr [class.is-deleted]="item._meta.deleted">
        <td>
          <input
            type="text"
            pInputText
            class="inputfield w-full"
            [(ngModel)]="item.label"
            [ngModelOptions]="{ standalone: true }"
            placeholder="e.g. Premium oak coffin"
          />
        </td>
        <td>
          <input
            type="number"
            pInputText
            class="inputfield w-full"
            min="1"
            [(ngModel)]="item.quantity"
            [ngModelOptions]="{ standalone: true }"
          />
        </td>
        <td>
          <p-inputNumber
            [(ngModel)]="item.price"
            [ngModelOptions]="{ standalone: true }"
            mode="currency"
            currency="AUD"
            locale="en-AU"
            [minFractionDigits]="0"
            [maxFractionDigits]="2"
            placeholder="(optional)"
          ></p-inputNumber>
        </td>
        <td class="in-fee-cell">
          <p-inputSwitch
            [(ngModel)]="item.includeInServiceFee"
            [ngModelOptions]="{ standalone: true }"
          ></p-inputSwitch>
        </td>
        <td class="row-actions">
          <button
            *ngIf="!item._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-text"
            (click)="onRemoveItem(item)"
          ></button>
          <button
            *ngIf="item._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-refresh"
            class="p-button-rounded p-button-success p-button-text"
            (click)="onRestoreItem(item)"
          ></button>
        </td>
      </tr>
      <!-- Long-form public description: rendered under the item in the
           brochure site's itemised breakdown (replaces the old hand-authored
           /pricing row tables). Optional per item. -->
      <tr class="item-description-row" [class.is-deleted]="item._meta.deleted">
        <td colspan="5">
          <div class="text-500 text-sm mb-1">Public description — shown under this item on picaluna.com</div>
          <textarea
            class="w-full"
            pInputTextarea
            [(ngModel)]="item.description"
            [ngModelOptions]="{ standalone: true }"
            rows="2"
            placeholder="Public description shown under this item on picaluna.com (optional) — e.g. what the transfer covers, when weekend rates apply."
          ></textarea>
        </td>
      </tr>
      <tr class="item-description-row" [class.is-deleted]="item._meta.deleted">
        <td colspan="5">
          <div class="text-500 text-sm mb-1">Footnote — shown on picaluna.com (required reason when the item is out of the service fee)</div>
          <div class="note-cell">
            <span *ngIf="markerFor(item)" class="fee-marker" title="Passed through at cost">{{ markerFor(item) }}</span>
            <input
              type="text"
              pInputText
              class="inputfield w-full"
              [(ngModel)]="item.note"
              [ngModelOptions]="{ standalone: true }"
              [placeholder]="item.includeInServiceFee === false ? 'Reason (shown as footnote)' : '(optional)'"
            />
          </div>
        </td>
      </tr>
      </ng-container>
      <tr *ngIf="items.length === 0">
        <td colspan="5" class="empty-row">No items yet — add one to start building this package.</td>
      </tr>
    </tbody>
  </table>

  <div class="items-footer">
    <button
      pButton
      pRipple
      type="button"
      label="Add item"
      icon="pi pi-plus"
      class="p-button-text"
      (click)="onAddItem()"
    ></button>
  </div>

  <div class="price-breakdown" *ngIf="hasPricedItems">
    <div class="bd-row">
      <span>Fee-bearing sub-total</span>
      <span>{{ feeBearingSubtotal | currency:'AUD' }}</span>
    </div>
    <div class="bd-row">
      <span>Service fee ({{ feePercent }}%)</span>
      <span>{{ serviceFeeAmount | currency:'AUD' }}</span>
    </div>
    <div class="bd-row" *ngIf="passThroughTotal > 0">
      <span>Pass-through (at cost)</span>
      <span>{{ passThroughTotal | currency:'AUD' }}</span>
    </div>
    <div class="bd-row total">
      <span>Computed total</span>
      <span>{{ computedTotal | currency:'AUD' }}</span>
    </div>
    <div class="bd-actions">
      <button
        pButton
        pRipple
        type="button"
        label="Use this total"
        icon="pi pi-arrow-up"
        class="p-button-text p-button-sm"
        (click)="useComputedTotal()"
      ></button>
    </div>
    <ul class="footnotes" *ngIf="excludedItems().length">
      <li *ngFor="let item of excludedItems()">
        <span class="fee-marker">{{ markerFor(item) }}</span>
        {{ item.label || '(item)' }} — passed through at cost, not subject to the service fee<span *ngIf="item.note">: {{ item.note }}</span>
      </li>
    </ul>
  </div>

  <div class="footer-buttons">
    <button
      pButton
      pRipple
      type="button"
      label="Cancel"
      class="p-button-secondary"
      [disabled]="saving"
      (click)="onCancel()"
    ></button>
    <button
      pButton
      pRipple
      type="submit"
      label="Save"
      icon="pi pi-check"
      [loading]="saving"
      [disabled]="form.invalid"
    ></button>
  </div>

</form>
